const LICIENSE =
  "Ngo9BigBOggjHTQxAR8/V1NGaF1cWGhAYVFwWmFZfV1gfV9DZVZSQWY/P1ZhSXxQdk1hXn1fdXFWQGFcUkc=";
export default LICIENSE;
